import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const HeaderContainer = styled.header`
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background: rgba(247, 243, 235, 0.82);
  border-bottom: 1px solid rgba(35, 32, 28, 0.1);
  backdrop-filter: blur(10px);

  @media (max-width: 768px) {
    padding: 14px 16px;
  }
`;

const Logo = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  color: #1f1d18;
`;

const LogoImage = styled.img`
  height: 30px;
  width: auto;
`;

const Wordmark = styled.span`
  font-family: "Cormorant Garamond", Georgia, serif;
  font-size: 1.55rem;
  font-weight: 600;
  letter-spacing: 0.01em;

  @media (max-width: 420px) {
    display: none;
  }
`;

const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const ContactLink = styled.a`
  color: #23201c;
  text-decoration: none;
  font-size: 0.76rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  padding: 10px 18px;
  border: 1.5px solid rgba(35, 32, 28, 0.28);
  border-radius: 999px;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease;

  @media (hover: hover) {
    &:hover {
      background-color: #23201c;
      border-color: #23201c;
      color: #f7f3eb;
    }
  }
`;

const ElciLink = styled(ContactLink)`
  background-color: #23201c;
  border-color: #23201c;
  color: #f7f3eb;

  @media (hover: hover) {
    &:hover {
      background-color: #b8450c;
      border-color: #b8450c;
      color: #f7f3eb;
    }
  }
`;

function Header() {
  return (
    <HeaderContainer>
      <Logo to="/" title="Precipex home">
        <LogoImage src="/logo.png" alt="Precipex" />
        <Wordmark>Precipex</Wordmark>
      </Logo>

      <Nav>
        <ElciLink href="https://elci.life" target="_blank" rel="noopener noreferrer">
          Try ELCI
        </ElciLink>
        <ContactLink href="mailto:info@precipex.com" target="_blank" rel="noopener noreferrer">
          Contact
        </ContactLink>
      </Nav>
    </HeaderContainer>
  );
}

export default Header;
